var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_34_269",
    "data-name": "Component 34 \\u2013 269",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.171,
    height: 4.251,
    viewBox: "0 0 14.171 4.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ellips"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27232",
    "data-name": "Rectangle 27232",
    width: 4.251,
    height: 14.171,
    fill: "#6c757d",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_358",
    "data-name": "Mask Group 358",
    transform: "translate(0 4.251) rotate(-90)",
    clipPath: "url(#ellips)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_21_",
    "data-name": "svgexport-6 (21)",
    transform: "translate(0.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10113",
    "data-name": "Group 10113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10112",
    "data-name": "Group 10112"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815",
    "data-name": "Ellipse 2815",
    cx: 1.575,
    cy: 1.575,
    r: 1.575,
    fill: "#6c757d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10115",
    "data-name": "Group 10115",
    transform: "translate(0 5.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10114",
    "data-name": "Group 10114"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2816",
    "data-name": "Ellipse 2816",
    cx: 1.575,
    cy: 1.575,
    r: 1.575,
    fill: "#6c757d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10117",
    "data-name": "Group 10117",
    transform: "translate(0 11.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10116",
    "data-name": "Group 10116"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2817",
    "data-name": "Ellipse 2817",
    cx: 1.575,
    cy: 1.575,
    r: 1.575,
    fill: "#6c757d"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllips);
export default __webpack_public_path__ + "static/media/ellips.1d4d392510b35ace6e249a713050a61a.svg";
export { ForwardRef as ReactComponent };